import React, { useState } from "react";
import Pagination from "../Pagination";

const ContactTable = ({ data, currentPage, totalPages, onPageChange }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleClose = () => setSelectedItem(null);
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-gray-700 text-white rounded-lg">
        <thead>
          <tr className="text-left border-b border-gray-600">
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Email</th>
            <th className="px-4 py-3">Phone</th>
            <th className="px-4 py-3">Message</th>

            <th className="px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item.id}
                className="border-b border-gray-600 hover:bg-gray-600 transition"
              >
                <td className="px-4 py-3">{item.name}</td>
                <td className="px-4 py-3">{item.email}</td>
                <td className="px-4 py-3">{item.phone}</td>
                <td className="px-4 py-3">
                  {item.message.split(" ").slice(0, 10).join(" ")}
                  {item.message.split(" ").length > 10 ? "..." : ""}
                </td>

                <td className="px-4 py-3 flex gap-2">
                  <button
                    onClick={() => setSelectedItem(item)}
                    className="px-2 py-1 bg-blue-500 rounded hover:bg-blue-600"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="mt-4 flex justify-center">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
      {selectedItem && (
        <div
          onClick={handleClose}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4"
        >
          {/* Modal */}
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden animate-[fadeIn_.3s_ease]"
          >
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h2 className="text-lg md:text-xl font-semibold text-gray-800">
                Contact Details
              </h2>
              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-black text-xl"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-5">
              {/* Info Grid */}
              <div className="grid grid-cols-1 gap-4 text-sm md:text-base">
                <div>
                  <p className="text-gray-500">Name</p>
                  <p className="font-medium text-gray-800">
                    {selectedItem.name}
                  </p>
                </div>

                <div>
                  <p className="text-gray-500">Email</p>
                  <p className="font-medium text-gray-800 break-all">
                    {selectedItem.email}
                  </p>
                </div>

                <div>
                  <p className="text-gray-500">Phone</p>
                  <p className="font-medium text-gray-800">
                    {selectedItem.phone}
                  </p>
                </div>
              </div>

              {/* Message Box */}
              <div>
                <p className="text-gray-500 mb-2">Message</p>
                <div className="bg-gray-100 rounded-lg p-4 max-h-[200px] overflow-y-auto text-gray-700 leading-relaxed">
                  {selectedItem.message}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t flex justify-end">
              <button
                onClick={handleClose}
                className="px-5 py-2 bg-black text-white rounded-lg hover:opacity-90 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactTable;
